<script lang="ts">
  import { Col, Row } from "sveltestrap";
  import Card from "../../Core/Card.svelte";
  import { Totalearning } from "../../../Data/Chart/Widget/ChartPage/Chart";
  import { chart } from "svelte-apexcharts";
  import data from "../../../Data/ComponentData/WidgetData/Chartpage/TotalEarning.json";
  import { TotalEarning } from "../../../utils/Constant/Constant";
</script>

<Col xl="5">
  <Card cardProps="o-hidden" cardHeaderprops="pb-0" headerTitle={TotalEarning} cardBodyprops="pt-0 bottom-content">
    <div class="bar-chart-widget" slot="contentbody">
      <Row>
        <Col>
          <div id="chart-widget5">
            <div use:chart={Totalearning} />
          </div>
        </Col>
      </Row>
      <Row class="text-center">
        {#each data.totalearning as chartItem}
          <Col xs="4" class="b-r-light">
            <div>
              <span class="font-primary">{chartItem.percentage}
                <i class="icon-angle-up f-12 ms-1" />
              </span>
              <span class="text-muted block-bottom">{chartItem.time}</span>
              <h4 class="num m-0">
                <span class="counter color-bottom">{chartItem.count}</span>M
              </h4>
            </div>
          </Col>
        {/each}
      </Row>
    </div>
  </Card>
</Col>
